import { useParams, Navigate } from "react-router-dom";

// Maps old Wix /product-page/<slug> URLs to the new /product/<slug> routes
// so existing links & search results keep working (preserves SEO link equity).
const LEGACY_MAP = {
  "bpc-157": "bpc-157",
  "cjc-1295ipamorelin-no-dac-55mg": "cjc-1295-ipamorelin",
  "cjc-1295-ipamorelin": "cjc-1295-ipamorelin",
  "nad-500": "nad-plus-500",
  "nad-plus-500": "nad-plus-500",
  "tirzepatide-": "glp2-10mg",
  "tirzepatide": "glp2-10mg",
  "glp2-10mg": "glp2-10mg",
  "klow-80": "klow-80",
  "klow": "klow-80",
  "tesamorelin-10mg": "tesamorelin-10mg",
  "tesamorelin": "tesamorelin-10mg",
  "retatrutide-20mg": "retatrutide-20mg",
  "retatrutide-30mg": "retatrutide-30mg",
  "retatrutide": "retatrutide-20mg",
  "glutathione-1500mg": "glutathione-1500mg",
  "glutathione": "glutathione-1500mg",
  "bacteriostatic-water-10ml": "bacteriostatic-water-10ml",
  "bacteriostatic-water": "bacteriostatic-water-10ml",
  "glow-70mg": "glow-70mg",
  "glow": "glow-70mg",
};

export default function LegacyRedirect() {
  const { slug } = useParams();
  const key = (slug || "").toLowerCase();
  const target = LEGACY_MAP[key];
  return <Navigate to={target ? `/product/${target}` : "/shop"} replace />;
}
